/*
 * Copyright (c) 2023. Collabro Limited
 */

import React, { useMemo } from "react";
import {
  createTheme,
  CssBaseline,
  PaletteMode,
  ThemeProvider,
} from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import RosterApp from "./components/RosterApp";
import { getTheme } from "./theme";
import { Theme } from "@mui/material/styles";

export const ColorModeContext = React.createContext({
  toggleColorMode: () => {},
  changeColorMode: (mode: PaletteMode) => {},
});

const queryClient = new QueryClient();

function App() {
  const [mode, setMode] = React.useState<PaletteMode>("light");
  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode: PaletteMode) =>
          prevMode === "light" ? "dark" : "light"
        );
      },
      changeColorMode: (mode: PaletteMode) => {
        setMode(mode);
      },
    }),
    []
  );

  const theme: Theme = React.useMemo(() => createTheme(getTheme(mode)), [mode]);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <QueryClientProvider client={queryClient}>
          <RosterApp />
        </QueryClientProvider>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
